//Constants for MainComponents

//Constants for Navbar.jsx
export const HOME = "Home";
export const ABOUT_ME = "About me";
export const WORKING_EXPERIENCES = "Working experiences";
export const PROJECTS = "Projects";
export const ACADEMIC_PROJECTS = "Academic Projects";
export const PERSONAL_PROJECTS = "Personal Projects";
export const ART_GALLERY = "Art Gallery";
export const PHOTO_GALLERY = "Photo Gallery";
export const EDUCATION = "Education";
export const CONTACT = "Contact";

//Constants for Footer.jsx
export const FOOTER_TITLE = "Let's keep in touch!";
export const LINKEDIN = "LinkedIn";
export const GITHUB = "Github";
export const COPYRIGHT = "Copyright";
export const ALL_RIGHTS_RESERVED = "The Minh Luong - ALL RIGHTS RESERVED";
export const PORTFOLIO_START_YEAR = "2021-";

//Constants for NotFound.jsx
export const ERROR_404 = "404";
export const ERROR_MESSAGE = "Whoops! It seems we've hit a dead end. Let's get back on track. ";
export const NAVIGATE_BACK = "Navigate back to the homepage to continue your exploration";
export const HINTS = "You can still use the back button or the navbar to navigate back to the homepage.";
export const SEE_YOU = "See you there!";
